import type { Component } from "vue";
import type { PredefinedNotificationRequestOptions, PredefinedNotificationType } from "../Api/predefinedNotifications";
import PaymentReminderDetails from "./PaymentReminder/PaymentReminderDetails.vue";
import SingleCompetitorCategoriesDetails from "./SingleCompetitorCategories/SingleCompetitorCategoriesDetails.vue";

export type NotificationTypeDefinition = {
    /** Translation key describing who receives the notification. */
    audienceKey: string;
    /**
     * Type-specific part of the preview, rendered between the price and the total. Props: `data`, `eventTimezone`,
     * `loading` and `options` (emits `update:options` when the organizer changes what is sent, the modal then reloads).
     */
    details?: Component;
    /** Request options sent with the first preview, for types that cannot be previewed without them. */
    initialOptions?: () => PredefinedNotificationRequestOptions;
};

/**
 * Everything the generic modal needs to know about a type. A new type adds its entry here, its own folder with the
 * components it needs, and its not-possible reasons to `reasons.ts`.
 */
export const notificationTypes: Record<PredefinedNotificationType, NotificationTypeDefinition> = {
    paymentReminder: {
        audienceKey: "predefined_notification.audience.payment_reminder",
        details: PaymentReminderDetails,
    },
    singleCompetitorCategories: {
        audienceKey: "predefined_notification.audience.single_competitor_categories",
        details: SingleCompetitorCategoriesDetails,
        initialOptions: () => ({ variant: "changeOnly" }),
    },
};
